export const plPL = {
  common: {
    search: "Szukaj...",
    create: "Nowy",
    new: "Nowy",
    cancel: "Anuluj",
    delete: "Usuń",
    edit: "Edytuj",
    theme: "Motyw",
    signOut: "Wyloguj się",
    noMatches: "Brak pasujących wyników",
    tryDifferentSearch: "Spróbuj użyć innego hasła wyszukiwania.",
    light: "Jasny",
    dark: "Ciemny",
    system: "Systemowy",
    loading: "Ładowanie...",
    note: "Notatka",
    insight: "Wgląd",
    newSource: "Nowe źródło",
    newNotebook: "Nowy notatnik",
    newPodcast: "Nowy podcast",
    language: "Język",
    english: "Angielski",
    chinese: "Chiński (uproszczony)",
    japanese: "Japoński",
    french: "Francuski",
    russian: "Rosyjski",
    bengali: "Bengalski",
    spanish: "Hiszpański",
    catalan: "Kataloński",
    german: "Niemiecki",
    polish: "Polski",
    turkish: "Türkçe",
    source: "Źródło",
    notebook: "Notatnik",
    podcast: "Podcast",
    quickActions: "Szybkie akcje",
    quickActionsDesc: "Nawigacja, wyszukiwanie, pytania, motyw",
    appName: "Open Notebook",
    add: "Dodaj",
    remove: "Usuń",
    confirm: "Potwierdź",
    warning: "Ostrzeżenie",
    error: "Błąd",
    success: "Sukces",
    model: "Model",
    back: "Wstecz",
    next: "Dalej",
    done: "Gotowe",
    processing: "Przetwarzanie...",
    creating: "Tworzenie...",
    linked: "Powiązane",
    adding: "Dodawanie...",
    addSelected: "Dodaj zaznaczone",
    customModel: "Model niestandardowy",
    failed: "niepowodzenie",
    current: "Bieżący",
    save: "Zapisz",
    writeNote: "Napisz notatkę",
    batchMode: "Tryb wsadowy",
    optional: "Opcjonalne",
    type: "Typ",
    title: "Tytuł",
    created: "Utworzono {time}",
    updated: "Zaktualizowano {time}",
    actions: "Akcje",
    noResults: "Brak wyników",
    references: "Odwołania",
    refreshPage: "Spróbuj odświeżyć stronę",
    refresh: "Odśwież",
    aiGenerated: "Wygenerowane przez AI",
    human: "Człowiek",
    unknown: "Nieznane",
    notes: "Notatki",
    chat: "Czat",
    deleteForever: "Usuń trwale",
    connectionError: "Błąd połączenia",
    unableToConnect: "Nie można połączyć się z serwerem API",
    retryConnection: "Ponów połączenie",
    diagnosticInfo: "Informacje diagnostyczne",
    version: "Wersja",
    built: "Zbudowano",
    apiUrl: "Adres URL API",
    frontendUrl: "Adres URL frontendu",
    checkConsoleLogs: "Sprawdź konsolę przeglądarki, aby uzyskać szczegółowe logi (szukaj komunikatów 🔧 [Config])",
    yes: "Tak",
    no: "Nie",
    saving: "Zapisywanie...",
    description: "Opis",
    saveToNote: "Zapisz do notatki",
    copyToClipboard: "Kopiuj do schowka",
    close: "Zamknij",
    insights: "Wglądy",
    progress: "Postęp",
    deleting: "Usuwanie...",
    created_label: "Utworzono",
    updated_label: "Zaktualizowano",
    download: "Pobierz",
    saveChanges: "Zapisz zmiany",
    name: "Nazwa",
    default: "Domyślny",
    nameRequired: "Nazwa jest wymagana",
    modelConfiguration: "Konfiguracja modelu",
    resetToDefault: "Przywróć domyślne",
    reasoning: "Rozumowanie",
    searchTerms: "Hasła wyszukiwania",
    strategy: "Strategia",
    individualAnswers: "Pojedyncze odpowiedzi ({count})",
    finalAnswer: "Ostateczna odpowiedź",
    notebookLabel: "Notatnik: {name}",
    itemNotFound: "Nie udało się odnaleźć elementu ({type})",
    accessibility: {
      transformationViews: "Widoki transformacji",
      searchKB: "Zadaj pytanie lub przeszukaj swoją bazę wiedzy",
      enterQuestion: "Wpisz pytanie, aby zapytać bazę wiedzy",
      enterSearch: "Wpisz zapytanie wyszukiwania",
      searchKBBtn: "Przeszukaj bazę wiedzy",
      podcastViews: "Widoki podcastów",
      ytVideo: "Film w serwisie YouTube",
      askResponse: "Odpowiedź na pytanie",
      searchNotebooks: "Przeszukaj notatniki",
    },
    url: "URL",
    errorDetails: "Szczegóły błędu",
    editTransformation: "Edytuj transformację",
    retry: "Spróbuj ponownie",
    traditionalChinese: "Chiński (tradycyjny)",
    portuguese: "Portugalski",
    completed: "zakończono",
    saveSuccess: "Zapisano pomyślnie",
    contextModes: {
      off: "Nieuwzględniane w czacie",
      insights: "Tylko wglądy",
      full: "Pełna treść",
      clickToCycle: "Kliknij, aby przełączyć",
    },
    clickToEdit: "Kliknij, aby edytować",
  },
  apiErrors: {
    notebookNotFound: "Nie znaleziono notatnika",
    sourceNotFound: "Nie znaleziono źródła",
    transformationNotFound: "Nie znaleziono transformacji",
    fileUploadFailed: "Przesyłanie pliku nie powiodło się",
    urlRequired: "Adres URL jest wymagany dla typu „link”",
    contentRequired: "Treść jest wymagana dla typu „tekst”",
    invalidSourceType: "Nieprawidłowy typ źródła",
    processingFailed: "Przetwarzanie nie powiodło się",
    failedToQueue: "Nie udało się dodać do kolejki przetwarzania",
    invalidSortBy: "Pole sortowania musi mieć wartość type, title, created, updated, insights_count lub embedded",
    invalidSortOrder: "Kolejność sortowania musi mieć wartość „asc” lub „desc”",
    accessDenied: "Odmowa dostępu do pliku",
    fileNotFoundOnServer: "Nie znaleziono pliku na serwerze",
    searchFailed: "Wyszukiwanie nie powiodło się",
    askFailed: "Zapytanie nie powiodło się",
    pleaseEnterQuestion: "Wpisz pytanie",
    pleaseConfigureModels: "Skonfiguruj wszystkie wymagane modele",
    failedToCreateSession: "Nie udało się utworzyć sesji",
    failedToUpdateSession: "Nie udało się zaktualizować sesji",
    failedToDeleteSession: "Nie udało się usunąć sesji",
    failedToSendMessage: "Nie udało się wysłać wiadomości",
    unauthorized: "Brak autoryzacji, sprawdź swoje hasło",
    invalidPassword: "Nieprawidłowe hasło",
    embeddingModelRequired: "Ta funkcja wymaga modelu osadzania. Skonfiguruj go w sekcji Modele.",
    strategyModelNotFound: "Nie znaleziono modelu strategii",
    answerModelNotFound: "Nie znaleziono modelu odpowiedzi",
    finalAnswerModelNotFound: "Nie znaleziono modelu ostatecznej odpowiedzi",
    noAnswerGenerated: "Nie udało się wygenerować odpowiedzi",
    genericError: "Wystąpił nieoczekiwany błąd",
  },
  connectionErrors: {
    apiTitle: "Nie można połączyć się z serwerem API",
    apiDesc: "Nie udało się nawiązać połączenia z serwerem API Open Notebook",
    dbTitle: "Połączenie z bazą danych nie powiodło się",
    dbDesc: "Serwer API działa, ale baza danych jest niedostępna",
    troubleshooting: "Zwykle oznacza to, że:",
    apiUnreachable1: "Serwer API nie jest uruchomiony",
    apiUnreachable2: "Serwer API działa pod innym adresem",
    apiUnreachable3: "Problemy z łącznością sieciową",
    dbFailed1: "SurrealDB nie jest uruchomiony",
    dbFailed2: "Ustawienia połączenia z bazą danych są nieprawidłowe",
    dbFailed3: "Problemy sieciowe między API a bazą danych",
    quickFixes: "Szybkie rozwiązania:",
    setApiUrl: "Ustaw zmienną środowiskową API_URL:",
    checkSurreal: "Sprawdź, czy SurrealDB jest uruchomiony:",
    seeDocumentation: "Szczegółowe instrukcje konfiguracji znajdziesz tutaj:",
    docLink: "Dokumentacja Open Notebook",
    showTechnical: "Pokaż szczegóły techniczne",
    attemptedUrl: "Próbowany adres URL",
    message: "Komunikat",
    technicalDetails: "Szczegóły techniczne",
    stackTrace: "Ślad stosu",
    retryLabel: "Ponów połączenie",
    retryHint: "Naciśnij R lub kliknij przycisk, aby spróbować ponownie",
    dockerLabel: "Dla Dockera",
    localDevLabel: "Dla środowiska lokalnego",
  },
  auth: {
    loginTitle: "Open Notebook",
    loginDesc: "Wpisz hasło, aby uzyskać dostęp do aplikacji",
    passwordPlaceholder: "Hasło",
    signingIn: "Logowanie...",
    signIn: "Zaloguj się",
    connectErrorHint: "Nie można połączyć się z serwerem. Sprawdź, czy API jest uruchomione.",
  },
  navigation: {
    collect: "Zbieraj",
    process: "Przetwarzaj",
    create: "Twórz",
    manage: "Zarządzaj",
    sources: "Źródła",
    notebooks: "Notatniki",
    askAndSearch: "Pytaj i szukaj",
    podcasts: "Podcasty",
    models: "Modele",
    transformations: "Transformacje",
    transformation: "Transformacja",
    settings: "Ustawienia",
    advanced: "Zaawansowane",
    nav: "Nawigacja",
    language: "Przełącz język",
    theme: "Motyw",
    ask: "Pytaj",
  },
  notebooks: {
    title: "Notatniki",
    newNotebook: "Nowy notatnik",
    searchPlaceholder: "Szukaj notatników...",
    archived: "Zarchiwizowane",
    archive: "Archiwizuj",
    unarchive: "Przywróć z archiwum",
    deleteNotebook: "Usuń notatnik",
    deleteNotebookDesc: "Czy na pewno chcesz usunąć „{name}”? Tej operacji nie można cofnąć.",
    deleteNotebookLoading: "Ładowanie podglądu usuwania...",
    deleteNotebookNotes: "Trwale usuniętych zostanie notatek: {count}.",
    deleteNotebookNoNotes: "Brak notatek do usunięcia.",
    deleteNotebookExclusiveSources: "Liczba źródeł istniejących tylko w tym notatniku: {count}.",
    deleteNotebookSharedSources: "Liczba źródeł współdzielonych z innymi notatnikami, które zostaną odłączone: {count}.",
    deleteNotebookNoSources: "Brak źródeł w tym notatniku.",
    deleteExclusiveSourcesLabel: "Usuń źródła wyłączne",
    keepExclusiveSourcesLabel: "Odłącz i zachowaj je",
    activeNotebooks: "Aktywne notatniki",
    archivedNotebooks: "Zarchiwizowane notatniki",
    tileView: "Widok kafelków",
    listView: "Widok listy",
    notFound: "Nie znaleziono notatnika",
    notFoundDesc: "Żądany notatnik nie istnieje.",
    updated: "Zaktualizowano",
    namePlaceholder: "Nazwa notatnika",
    addDescription: "Dodaj opis...",
    noNotesYet: "Brak notatek",
    deleteNote: "Usuń notatkę",
    deleteNoteConfirm: "Czy na pewno chcesz usunąć tę notatkę? Tej operacji nie można cofnąć.",
    noteCreatedSuccess: "Notatka utworzona pomyślnie",
    failedToCreateNote: "Nie udało się utworzyć notatki",
    noteUpdatedSuccess: "Notatka zaktualizowana pomyślnie",
    failedToUpdateNote: "Nie udało się zaktualizować notatki",
    noteDeletedSuccess: "Notatka usunięta pomyślnie",
    failedToDeleteNote: "Nie udało się usunąć notatki",
    createNew: "Utwórz nowy notatnik",
    createNewDesc: "Wpisz nazwę i opcjonalny opis, aby rozpocząć.",
    descPlaceholder: "Dodaj tutaj więcej informacji o tym notatniku...",
    createSuccess: "Notatnik utworzony pomyślnie",
    updateSuccess: "Notatnik zaktualizowany pomyślnie",
    deleteSuccess: "Notatnik usunięty pomyślnie",
    recentlyViewed: "Ostatnio przeglądane",
    toggleRecentlyViewed: "Przełącz ostatnio przeglądane",
    recentlyViewedNotebook: "Notatnik",
    recentlyViewedSource: "Źródło",
    lastViewed: "Wyświetlono {{time}}",
  },
  sources: {
    bulkContext: "Kontekst",
    includeAllInContext: "Uwzględnij wszystkie w kontekście",
    includeAllInsights: "Uwzględnij wszystkie (tylko wnioski)",
    includeAllFull: "Uwzględnij wszystkie (pełna treść)",
    excludeAllFromContext: "Wyklucz wszystkie z kontekstu",
    title: "Źródła",
    add: "Dodaj źródło",
    addNew: "Dodaj nowe źródło",
    addExisting: "Dodaj istniejące źródło",
    delete: "Usuń źródło",
    statusPreparing: "Przygotowywanie",
    statusQueued: "W kolejce",
    statusProcessing: "Przetwarzanie",
    statusCompleted: "Zakończone",
    statusFailed: "Niepowodzenie",
    statusPreparingDesc: "Przygotowywanie do przetwarzania",
    statusQueuedDesc: "Oczekiwanie na przetworzenie",
    statusProcessingDesc: "Trwa przetwarzanie",
    statusCompletedDesc: "Przetworzono pomyślnie",
    statusFailedDesc: "Przetwarzanie nie powiodło się",
    failedToLoad: "Nie udało się załadować źródeł",
    allSourcesDesc: "Tutaj zobaczysz wszystkie swoje źródła. Możesz dodawać nowe lub zarządzać istniejącymi.",
    allSources: "Wszystkie źródła",
    insights: "Wglądy",
    yes: "Tak",
    no: "Nie",
    loadingMore: "Ładowanie kolejnych...",
    noSourcesYet: "Brak źródeł",
    allSourcesDescShort: "Tutaj zobaczysz wszystkie swoje źródła.",
    cannotSaveNoteNoNotebook: "Nie można zapisać notatki: brak dostępnego identyfikatora notatnika",
    createFirstSource: "Dodaj pierwsze źródło, aby zacząć budować bazę wiedzy.",
    deleteSourceConfirm: "Czy na pewno chcesz usunąć to źródło?",
    deleteConfirm: "Czy na pewno chcesz to usunąć?",
    deleteConfirmWithTitle: "Czy na pewno chcesz usunąć „{title}”?",
    deleteSuccess: "Źródło usunięte pomyślnie. Uwaga: aby usunąć plik z magazynu, musisz włączyć opcję „usuń plik” na stronie ustawień.",
    failedToDelete: "Nie udało się usunąć źródła",
    sourceQueued: "Źródło w kolejce",
    sourceQueuedDesc: "Źródło przekazano do przetwarzania w tle. Postęp możesz śledzić na liście źródeł.",
    sourceAddedSuccess: "Źródło dodane pomyślnie",
    failedToAddSource: "Nie udało się dodać źródła",
    sourceUpdatedSuccess: "Źródło zaktualizowane pomyślnie",
    failedToUpdateSource: "Nie udało się zaktualizować źródła",
    sourceDeletedSuccess: "Źródło usunięte pomyślnie",
    failedToDeleteSource: "Nie udało się usunąć źródła",
    fileUploadedSuccess: "Plik przesłany pomyślnie",
    failedToUploadFile: "Nie udało się przesłać pliku",
    sourceRequeued: "Ponowienie źródła w kolejce",
    sourceRequeuedDesc: "Źródło zostało ponownie dodane do kolejki przetwarzania.",
    failedToRetry: "Ponowienie nie powiodło się",
    sourcesAddedToNotebook: "Dodano źródeł do notatnika: {count}",
    failedToAddSourcesToNotebook: "Nie udało się dodać źródeł do notatnika",
    partialAddSuccess: "Dodano źródeł: {success}, niepowodzeń: {failed}",
    sourceRemovedFromNotebook: "Źródło usunięte z notatnika pomyślnie",
    failedToRemoveSourceFromNotebook: "Nie udało się usunąć źródła z notatnika",
    removeConfirm: "Czy na pewno chcesz usunąć to z notatnika?",
    checking: "Sprawdzanie...",
    untitledSource: "Źródło bez tytułu",
    maxItems: "maks. {count}",
    insightsCount: "Wglądy: {count}",
    details: "Szczegóły",
    detailsTitle: "Szczegóły źródła",
    content: "Treść",
    metadata: "Metadane",
    type: {
      link: "Link",
      file: "Plik",
      text: "Tekst",
    },
    id: "Identyfikator źródła",
    topics: "Tematy",
    embedded: "Osadzone",
    notEmbedded: "Nieosadzone",
    embedContent: "Osadź treść",
    embedding: "Osadzanie...",
    alreadyEmbedded: "Już osadzone",
    downloadFile: "Pobierz plik",
    fileUnavailable: "Plik niedostępny",
    preparing: "Przygotowywanie...",
    generateNewInsight: "Wygeneruj nowy wgląd",
    selectTransformation: "Wybierz transformację...",
    noInsightsYet: "Brak wglądów",
    createFirstInsight: "Utwórz pierwszy wgląd, korzystając z transformacji powyżej",
    viewInsight: "Zobacz wgląd",
    deleteInsight: "Usuń wgląd",
    deleteInsightConfirm: "Czy na pewno chcesz usunąć ten wgląd? Tej operacji nie można cofnąć.",
    insightGenerationStarted: "Rozpoczęto generowanie wglądu. Pojawi się wkrótce.",
    editNote: "Edytuj notatkę",
    createNote: "Utwórz notatkę",
    addTitle: "Dodaj tytuł...",
    untitledNote: "Notatka bez tytułu",
    writeNotePlaceholder: "Napisz tutaj treść notatki...",
    saveNote: "Zapisz notatkę",
    createNoteBtn: "Utwórz notatkę",
    createFirstNote: "Utwórz pierwszą notatkę, aby zapisać wglądy i obserwacje.",
    urlLabel: "Adres(y) URL *",
    fileLabel: "Plik(i) *",
    textContentLabel: "Treść tekstowa *",
    enterUrlsPlaceholder: "Wpisz adresy URL, po jednym w wierszu\nhttps://example.com/artykul1\nhttps://example.com/artykul2",
    batchUrlHint: "Wklej wiele adresów URL (po jednym w wierszu), aby zaimportować je wsadowo",
    invalidUrlsDetected: "Wykryto nieprawidłowe adresy URL:",
    lineLabel: "Wiersz {line}",
    fixInvalidUrls: "Popraw lub usuń nieprawidłowe adresy URL, aby kontynuować",
    selectMultipleFilesHint: "Wybierz wiele plików, aby zaimportować je wsadowo. Obsługiwane: Dokumenty (PDF, DOC, DOCX, PPT, XLS, EPUB, TXT, MD), Media (MP4, MP3, WAV, M4A), Obrazy (JPG, PNG), Archiwa (ZIP)",
    selectedFiles: "Wybrane pliki:",
    textPlaceholder: "Wklej lub wpisz tutaj swoją treść...",
    htmlDetected: "Wykryto treść HTML. Po przetworzeniu zostanie przekonwertowana na Markdown.",
    titlePlaceholder: "Nadaj źródłu opisowy tytuł",
    batchTitlesAuto: "Tytuły zostaną wygenerowane automatycznie dla każdego źródła.",
    batchCommonSettings: "Te same notatniki i transformacje zostaną zastosowane do wszystkich elementów.",
    urlsCount: "Liczba adresów URL: {count}",
    filesCount: "Liczba plików: {count}",
    addSource: "Dodaj źródło",
    notEmbeddedAlert: "Treść nieosadzona",
    notEmbeddedDesc: "Ta treść nie została osadzona na potrzeby wyszukiwania wektorowego. Osadzanie umożliwia zaawansowane wyszukiwanie i lepsze odnajdywanie treści.",
    openOnYoutube: "Otwórz w serwisie YouTube",
    urlCopied: "Skopiowano adres URL do schowka",
    viewSource: "Zobacz źródło",
    noInsightSelected: "Nie wybrano wglądu",
    sourceInsight: "Wgląd źródła",
    manageNotebooks: "Zarządzaj notatnikami",
    manageNotebooksDesc: "Zarządzaj notatnikami, które zawierają to źródło",
    noNotebooksAvailable: "Brak dostępnych notatników",
    loadFailed: "Nie udało się załadować szczegółów źródła",
    removeFromNotebook: "Usuń z notatnika",
    retryProcessing: "Ponów przetwarzanie",
    refreshContent: "Odśwież treść",
    deleteSource: "Usuń źródło",
    retry: "Ponów",
    addExistingTitle: "Dodaj istniejące źródła",
    addExistingDesc: "Wybierz istniejące źródła ze wszystkich notatników, aby dodać je do bieżącego.",
    searchPlaceholder: "Szukaj źródeł po nazwie lub adresie URL...",
    noNotebooksFound: "Nie znaleziono notatników.",
    showingFirst100: "Wyświetlanie pierwszych 100 źródeł. Użyj wyszukiwania, aby znaleźć konkretne.",
    selectedCount: "Zaznaczono źródeł: {count}",
    added: "Dodano dnia {date}",
    addUrl: "Dodaj adres URL",
    uploadFile: "Prześlij plik",
    enterText: "Wpisz tekst",
    processDescription: "Treść zostanie przetworzona i przeanalizowana przez AI.",
    processingFiles: "Przetwarzanie plików...",
    titleRequired: "Tytuł jest wymagany dla treści tekstowej",
    titleGenerated: "Jeśli pozostawisz puste, tytuł zostanie wygenerowany na podstawie treści",
    batchCount: "Liczba elementów do przetworzenia: {count} {type}",
    enableEmbedding: "Włącz osadzanie na potrzeby wyszukiwania",
    embeddingDesc: "Umożliwia odnajdywanie tego źródła w wyszukiwaniu wektorowym i zapytaniach AI",
    embeddingAlways: "Osadzanie włączane automatycznie",
    embeddingAlwaysDesc: "Twoje ustawienia są skonfigurowane tak, aby zawsze osadzać treść na potrzeby wyszukiwania wektorowego.",
    embeddingNever: "Osadzanie wyłączone",
    embeddingNeverDesc: "Twoje ustawienia są skonfigurowane tak, aby pomijać osadzanie. Wyszukiwanie wektorowe nie będzie dostępne dla tego źródła.",
    changeInSettings: "Możesz to zmienić w Ustawieniach",
    notFound: "Nie znaleziono źródła",
    noContent: "Brak dostępnej treści",
    insightsDesc: "Wglądy wygenerowane na podstawie analizy modelu",
    uploadedFile: "Przesłany plik",
    fileUnavailableDesc: "Ten plik jest obecnie niedostępny z powodów związanych z systemem magazynowania.",
    batchSuccess: "Utworzono źródeł pomyślnie: {count}",
    batchFailed: "Nie udało się utworzyć wszystkich źródeł ({count})",
    batchPartial: "Powodzenia: {success}, niepowodzenia: {failed}",
    submittingSource: "Przekazywanie źródła do przetwarzania...",
    processingBatchSources: "Przetwarzanie źródeł: {count}. Może to chwilę potrwać.",
    processingSource: "Twoje źródło jest przetwarzane. Może to chwilę potrwać.",
    maxFilesAllowed: "Maksymalna liczba plików w partii: {count}",
  },
  chat: {
    sessions: "Sesje",
    sessionTitlePlaceholder: "Wpisz tutaj tytuł...",
    noSessions: "Brak sesji czatu",
    deleteSession: "Usuń sesję",
    deleteSessionDesc: "Czy na pewno chcesz usunąć tę sesję czatu? Tej operacji nie można cofnąć.",
    sendPlaceholder: "Zapytaj o cokolwiek dotyczące swoich źródeł...",
    sessionsTitle: "Sesje czatu",
    chatWith: "Czat z {name}",
    startConversation: "Rozpocznij rozmowę o tym elemencie ({type})",
    askQuestions: "Zadawaj pytania, aby lepiej zrozumieć treść",
    pressToSend: "Naciśnij {key}, aby wysłać",
    model: "Model",
    createToStart: "Utwórz sesję, aby rozpocząć.",
    chatWithNotebook: "Czat z notatnikiem",
    unableToLoadChat: "Nie można załadować czatu",
    noDescription: "Brak opisu",
    startByCreating: "Zacznij od utworzenia pierwszego notatnika, aby uporządkować swoje badania.",
    messagesCount: "Wiadomości: {count}",
    sessionCreated: "Utworzono sesję czatu",
    sessionUpdated: "Zaktualizowano sesję",
    sessionDeleted: "Usunięto sesję",
  },
  searchPage: {
    askAndSearch: "Pytaj i szukaj",
    chooseAMode: "Wybierz tryb",
    askBeta: "Pytaj (beta)",
    search: "Szukaj",
    askYourKb: "Zapytaj swoją bazę wiedzy (beta)",
    askYourKbDesc: "Model LLM odpowie na Twoje pytanie na podstawie dokumentów w Twojej bazie wiedzy.",
    question: "Pytanie",
    enterQuestionPlaceholder: "Wpisz pytanie...",
    pressToSubmit: "Naciśnij Cmd/Ctrl+Enter, aby wysłać",
    noEmbeddingModel: "Nie możesz użyć tej funkcji, ponieważ nie wybrano modelu osadzania. Skonfiguruj go na stronie Modele.",
    usingCustomModels: "Korzystanie z modeli niestandardowych",
    usingDefaultModels: "Korzystanie z modeli domyślnych",
    advanced: "Zaawansowane",
    strategy: "Strategia",
    answer: "Odpowiedź",
    final: "Ostateczna",
    ask: "Pytaj",
    processing: "Przetwarzanie...",
    saveToNotebooks: "Zapisz do notatników",
    searchDesc: "Przeszukaj swoją bazę wiedzy pod kątem konkretnych słów kluczowych lub pojęć",
    enterSearchPlaceholder: "Wpisz zapytanie wyszukiwania...",
    pressToSearch: "Naciśnij Enter, aby wyszukać",
    searchType: "Typ wyszukiwania",
    vectorSearchWarning: "Wyszukiwanie wektorowe wymaga modelu osadzania. Dostępne jest tylko wyszukiwanie tekstowe.",
    textSearch: "Wyszukiwanie tekstowe",
    vectorSearch: "Wyszukiwanie wektorowe",
    searchIn: "Szukaj w",
    searchSources: "Przeszukaj źródła",
    searchNotes: "Przeszukaj notatki",
    resultsFound: "Znaleziono wyników: {count}",
    matches: "Dopasowania ({count})",
    noResultsFor: "Brak wyników dla „{query}”",
    notSet: "Nie ustawiono",
    saveToNotebook: "Zapisz do notatnika",
    saveSuccess: "Pomyślnie zapisano do notatnika",
    saveError: "Nie udało się zapisać do notatnika",
    selectNotebook: "Wybierz notatnik",
    searchAndAsk: "Szukaj i pytaj",
    searchResultsFor: "Wyniki wyszukiwania dla „{query}”",
    askAbout: "Zapytaj o „{query}”",
    orSearchKb: "Lub przeszukaj swoją bazę wiedzy",
    saving: "Zapisywanie...",
    advancedModelTitle: "Zaawansowany wybór modeli",
    advancedModelDesc: "Wybierz konkretne modele dla każdego etapu procesu Pytania",
    strategyModel: "Model strategii",
    answerModel: "Model odpowiedzi",
    finalAnswerModel: "Model ostatecznej odpowiedzi",
    selectStrategyPlaceholder: "Wybierz model strategii",
    selectAnswerPlaceholder: "Wybierz model odpowiedzi",
    selectFinalPlaceholder: "Wybierz model ostatecznej odpowiedzi",
    saveChanges: "Zapisz zmiany",
    processingQuestion: "Przetwarzanie pytania...",
  },
  podcasts: {
    generateEpisode: "Wygeneruj odcinek podcastu",
    generateEpisodeDesc: "Wybierz treść do uwzględnienia i skonfiguruj szczegóły odcinka przed wygenerowaniem nowego odcinka podcastu.",
    content: "Treść",
    contentDesc: "Wybierz notatniki, źródła i notatki, które chcesz uwzględnić w tym odcinku.",
    itemsSelected: "Zaznaczono elementów: {count}",
    tokens: "Tokeny: {count}",
    chars: "Znaki: {count}",
    loadingNotebooks: "Ładowanie notatników...",
    noNotebooksFoundInPodcasts: "Nie znaleziono notatników. Utwórz notatnik i dodaj treść przed wygenerowaniem podcastu.",
    noContentSelected: "Nie wybrano treści",
    summary: "Podsumowanie",
    fullContent: "Pełna treść",
    untitledSource: "Źródło bez tytułu",
    untitledNote: "Notatka bez tytułu",
    episodeSettings: "Ustawienia odcinka",
    episodeProfile: "Profil odcinka",
    episodeProfilePlaceholder: "Wybierz profil odcinka",
    episodeName: "Nazwa odcinka",
    episodeNamePlaceholder: "np. AI i przyszłość pracy",
    additionalInstructions: "Dodatkowe instrukcje",
    instructionsPlaceholder: "Dodatkowe wskazówki dołączane do briefingu odcinka...",
    generating: "Generowanie...",
    generate: "Generuj",
    hostPlaceholder: "Prowadzący {number}",
    profileRequired: "Wymagany profil odcinka",
    profileRequiredDesc: "Wybierz profil odcinka przed wygenerowaniem podcastu.",
    nameRequired: "Wymagana nazwa odcinka",
    nameRequiredDesc: "Podaj nazwę odcinka.",
    addContext: "Dodaj kontekst",
    addContextDesc: "Wybierz co najmniej jedno źródło lub notatkę do uwzględnienia w odcinku.",
    generationFailed: "Generowanie podcastu nie powiodło się",
    speakerProfile: "Profil mówcy",
    usesSpeakerProfile: "Używa profilu mówcy",
    sources: "Źródła",
    notes: "Notatki",
    noSources: "Brak dostępnych źródeł w tym notatniku.",
    noNotes: "Brak dostępnych notatek w tym notatniku.",
    selectMode: "Wybierz tryb",
    buildContextFailed: "Nie udało się zbudować kontekstu. Sprawdź swoje zaznaczenia.",
    podcastTaskStarted: "Zadanie podcastu rozpoczęte",
    loadingProfiles: "Ładowanie profili odcinków...",
    noProfilesFound: "Nie znaleziono profili odcinków. Utwórz profil odcinka przed wygenerowaniem podcastu.",
    listTitle: "Podcasty",
    listDesc: "Śledź wygenerowane odcinki i zarządzaj wielokrotnego użytku profilami.",
    chooseAView: "Wybierz widok",
    episodesTab: "Odcinki",
    templatesTab: "Profile",
    overviewTitle: "Przegląd odcinków",
    overviewDesc: "Monitoruj zadania generowania podcastów i przeglądaj gotowe materiały.",
    generateBtn: "Wygeneruj podcast",
    total: "Łącznie",
    processingLabel: "Przetwarzanie",
    completedLabel: "Zakończone",
    failedLabel: "Niepowodzenie",
    pendingLabel: "Oczekujące",
    loadErrorTitle: "Nie udało się załadować odcinków",
    loadErrorDesc: "Nie mogliśmy pobrać najnowszych odcinków podcastu. Spróbuj ponownie za chwilę.",
    loadingEpisodes: "Ładowanie odcinków…",
    noEpisodesYet: "Brak odcinków podcastu. Wygeneruj pierwszy z poziomu notatnika lub interfejsu czatu źródła.",
    statusRunningTitle: "Obecnie przetwarzane",
    statusRunningDesc: "Odcinki, dla których aktywnie generowane są materiały.",
    statusPendingTitle: "W kolejce / Oczekujące",
    statusPendingDesc: "Przesłane odcinki oczekujące na rozpoczęcie przetwarzania.",
    statusCompletedTitle: "Zakończone odcinki",
    statusCompletedDesc: "Gotowe do przeglądania, pobrania lub publikacji.",
    statusFailedTitle: "Nieudane odcinki",
    statusFailedDesc: "Odcinki, które napotkały problemy podczas generowania.",
    templatesWorkspaceTitle: "Obszar roboczy profili",
    templatesWorkspaceDesc: "Twórz wielokrotnego użytku konfiguracje odcinków i mówców na potrzeby szybkiej produkcji podcastów.",
    howTemplatesPowerTitle: "Jak profile napędzają generowanie podcastów",
    howTemplatesPowerDesc: "Profile dzielą proces tworzenia podcastu na dwa wielokrotnego użytku elementy. Łącz je dowolnie przy każdym generowaniu nowego odcinka.",
    episodeProfilesSetFormat: "Profile odcinków ustalają format",
    episodeProfilesList1: "Określ liczbę segmentów i sposób prowadzenia narracji",
    episodeProfilesList2: "Wybierz modele językowe używane do briefingu, tworzenia konspektu i pisania scenariusza",
    episodeProfilesList3: "Zapisz domyślne briefingi, aby każdy odcinek zaczynał się od spójnego tonu",
    speakerProfilesBringVoices: "Profile mówców ożywiają głosy",
    speakerProfilesList1: "Wybierz dostawcę i model syntezy mowy",
    speakerProfilesList2: "Zdefiniuj osobowość, tło i wskazówki dotyczące wymowy dla każdego mówcy",
    speakerProfilesList3: "Korzystaj z tych samych głosów prowadzących lub gości w różnych formatach odcinków",
    recommendedWorkflow: "Zalecany przepływ pracy",
    workflowStep1: "Utwórz profile mówców dla każdego potrzebnego głosu",
    workflowStep2: "Twórz profile odcinków, które odwołują się do tych mówców po nazwie",
    workflowStep3: "Generuj podcasty, wybierając profil odcinka pasujący do tematu",
    workflowHint: "Profile odcinków odwołują się do profili mówców po nazwie, dlatego rozpoczęcie od mówców pozwala uniknąć braków w przypisaniu głosów.",
    failedToLoadTemplates: "Nie udało się załadować danych profili",
    failedToLoadTemplatesDesc: "Upewnij się, że API jest uruchomione, i spróbuj ponownie. Niektóre sekcje mogą być niekompletne.",
    loadingTemplates: "Ładowanie profili…",
    speakerProfilesTitle: "Profile mówców",
    speakerProfilesDesc: "Skonfiguruj głosy i osobowości dla generowanych odcinków.",
    createSpeaker: "Utwórz mówcę",
    noSpeakerProfiles: "Brak profili mówców. Utwórz jeden, aby udostępnić profile odcinków.",
    noDescription: "Nie podano opisu.",
    usedByCount_one: "Używany przez 1 odcinek",
    usedByCount_other: "Używany przez {count} odcinków",
    usedByCount: "Używany przez {count} odcinków",
    unused: "Nieużywany",
    voiceId: "Identyfikator głosu",
    backstory: "Tło",
    personality: "Osobowość",
    edit: "Edytuj",
    duplicate: "Duplikuj",
    deleteSpeakerProfileTitle: "Usunąć profil mówcy?",
    deleteSpeakerProfileDesc: "Usunięcia „{name}” nie można cofnąć.",
    deleteSpeakerDisabledHint: "Usuń tego mówcę z profili odcinków, zanim go usuniesz.",
    deleting: "Usuwanie…",
    episodeProfilesTitle: "Profile odcinków",
    episodeProfilesDesc: "Zdefiniuj wielokrotnego użytku ustawienia generowania dla swoich audycji.",
    createProfile: "Utwórz profil",
    createSpeakerFirst: "Utwórz profil mówcy przed dodaniem profilu odcinka.",
    noEpisodeProfiles: "Brak profili odcinków. Utwórz jeden, aby rozpocząć generowanie podcastów.",
    speakerCreated: "Utworzono mówcę",
    speakerCreatedDesc: "Mówca „{name}” został pomyślnie dodany.",
    failedToCreateSpeaker: "Nie udało się utworzyć profilu mówcy",
    speakerUpdated: "Zaktualizowano mówcę",
    speakerUpdatedDesc: "Mówca „{name}” został pomyślnie zaktualizowany.",
    failedToUpdateSpeaker: "Nie udało się zaktualizować profilu mówcy",
    speakerDeleted: "Usunięto mówcę",
    speakerDeletedDesc: "Mówca „{name}” został pomyślnie usunięty.",
    failedToDeleteSpeaker: "Nie udało się usunąć profilu mówcy",
    speakerDuplicated: "Zduplikowano mówcę",
    speakerDuplicatedDesc: "Mówca „{name}” został pomyślnie zduplikowany.",
    failedToDuplicateSpeaker: "Nie udało się zduplikować profilu mówcy",
    generationStarted: "Rozpoczęto generowanie",
    generationStartedDesc: "Generowanie podcastu zostało dodane do kolejki.",
    failedToStartGeneration: "Nie udało się rozpocząć generowania",
    tryAgainMoment: "Spróbuj ponownie za chwilę.",
    deleteProfileTitle: "Usunąć profil?",
    deleteProfileDesc: "Spowoduje to usunięcie „{name}”. Istniejące odcinki zachowają swoje dane, ale nowe nie będą już korzystać z tej konfiguracji.",
    profileCreated: "Utworzono profil",
    profileCreatedDesc: "Profil odcinka „{name}” został pomyślnie utworzony.",
    failedToCreateProfile: "Nie udało się utworzyć profilu",
    profileUpdated: "Zaktualizowano profil",
    profileUpdatedDesc: "Profil odcinka „{name}” został pomyślnie zaktualizowany.",
    failedToUpdateProfile: "Nie udało się zaktualizować profilu",
    profileDeleted: "Usunięto profil",
    profileDeletedDesc: "Profil odcinka „{name}” został pomyślnie usunięty.",
    failedToDeleteProfile: "Nie udało się usunąć profilu",
    failedToDeleteProfileDesc: "Nie udało się usunąć profilu odcinka.",
    profileDuplicated: "Zduplikowano profil",
    profileDuplicatedDesc: "Profil odcinka „{name}” został pomyślnie zduplikowany.",
    failedToDuplicateProfile: "Nie udało się zduplikować profilu",
    episodeDeleted: "Usunięto odcinek",
    episodeDeletedDesc: "Odcinek został pomyślnie usunięty.",
    failedToDeleteEpisode: "Nie udało się usunąć odcinka",
    failedToDeleteSpeakerDesc: "Nie udało się usunąć profilu mówcy.",
    outlineModel: "Model konspektu",
    transcriptModel: "Model transkrypcji",
    segments: "Segmenty",
    defaultBriefingTitle: "Domyślny briefing",
    created: "Utworzono {time}",
    details: "Szczegóły",
    summaryTab: "Podsumowanie",
    outlineTab: "Konspekt",
    transcriptTab: "Transkrypcja",
    briefing: "Briefing",
    noOutline: "Brak dostępnego konspektu.",
    noTranscript: "Brak dostępnej transkrypcji.",
    deleteEpisodeTitle: "Usunąć odcinek?",
    deleteEpisodeDesc: "Spowoduje to trwałe usunięcie „{name}” i powiązanego pliku audio.",
    audioUnavailable: "Audio niedostępne",
    segment: "Segment",
    speaker: "Mówca",
    profile: "Profil",
    link: "Link",
    file: "Plik",
    embedded: "Osadzone",
    notEmbedded: "Nieosadzone",
    noSpeakerProfilesAvailable: "Brak dostępnych profili mówców",
    editEpisodeProfile: "Edytuj profil odcinka",
    createEpisodeProfile: "Utwórz profil odcinka",
    episodeProfileFormDesc: "Zdefiniuj, jak mają być generowane odcinki i jakiej konfiguracji mówców używają domyślnie.",
    noSpeakerProfilesDesc: "Utwórz profil mówcy przed skonfigurowaniem profilu odcinka.",
    profileName: "Nazwa profilu",
    profileNamePlaceholder: "np. Dyskusja techniczna",
    descriptionPlaceholder: "Krótkie podsumowanie, kiedy używać tego profilu",
    speakerConfig: "Konfiguracja mówców",
    selectSpeakerProfile: "Wybierz profil mówcy",
    outlineGeneration: "Generowanie konspektu",
    transcriptGeneration: "Generowanie transkrypcji",
    defaultBriefingPlaceholder: "Opisz strukturę, ton i cele dla tego formatu odcinka",
    editSpeakerProfile: "Edytuj profil mówcy",
    createSpeakerProfile: "Utwórz profil mówcy",
    speakerProfileFormDesc: "Skonfiguruj ustawienia syntezy mowy i zdefiniuj maksymalnie czterech mówców.",
    speakers: "Mówcy",
    speakersDesc: "Skonfiguruj od jednego do czterech głosów dla tego profilu.",
    addSpeaker: "Dodaj mówcę",
    speakerNumber: "Mówca {number}",
    backstoryPlaceholder: "Krótka biografia lub kontekst mówcy",
    personalityPlaceholder: "Opisz styl i ton",
    outlineModelRequired: "Model konspektu jest wymagany",
    transcriptModelRequired: "Model transkrypcji jest wymagany",
    defaultBriefingRequired: "Domyślny briefing jest wymagany",
    segmentsInteger: "Musi być liczbą całkowitą",
    segmentsMin: "Co najmniej 3 segmenty",
    segmentsMax: "Maksymalnie 20 segmentów",
    voiceIdRequired: "Identyfikator głosu jest wymagany",
    backstoryRequired: "Tło jest wymagane",
    personalityRequired: "Osobowość jest wymagana",
    speakerCountMin: "Wymagany jest co najmniej jeden mówca",
    speakerCountMax: "Możesz skonfigurować maksymalnie 4 mówców",
    delete: "Usuń",
    failedToDelete: "Nie udało się usunąć podcastu",
    retry: "Ponów",
    retrying: "Ponawianie…",
    retryStarted: "Rozpoczęto ponowienie",
    retryStartedDesc: "Przesłano nowe zadanie generowania podcastu.",
    failedToRetry: "Nie udało się ponowić odcinka",
    errorDetails: "Szczegóły błędu",
    language: "Język",
    languagePlaceholder: "Wybierz język (opcjonalnie)",
    podcastLanguage: "Język podcastu",
    selectOutlineModel: "Wybierz model konspektu",
    selectTranscriptModel: "Wybierz model transkrypcji",
    voiceModel: "Model głosu",
    voiceModelRequired: "Model głosu jest wymagany",
    selectVoiceModel: "Wybierz model głosu",
    perSpeakerTtsOverride: "Nadpisanie TTS dla poszczególnych mówców (opcjonalne)",
    useProfileDefault: "Użyj domyślnego dla profilu",
    setupRequired: "Wymagana konfiguracja",
    setupRequiredDesc: "Niektóre profile nie mają jeszcze skonfigurowanych modeli. Edytuj je, aby wybrać modele przed wygenerowaniem podcastów.",
    notConfigured: "Nieskonfigurowane",
  },
  settings: {
    contentProcessing: "Przetwarzanie treści",
    contentProcessingDesc: "Skonfiguruj sposób przetwarzania dokumentów i adresów URL",
    docEngine: "Silnik przetwarzania dokumentów",
    docEnginePlaceholder: "Wybierz silnik przetwarzania dokumentów",
    urlEngine: "Silnik przetwarzania adresów URL",
    urlEnginePlaceholder: "Wybierz silnik przetwarzania adresów URL",
    autoRecommended: "Automatyczny (zalecany)",
    simple: "Prosty",
    docling: "Docling",
    helpMeChoose: "Pomóż mi wybrać",
    docHelp: "· Docling jest nieco wolniejszy, ale dokładniejszy, zwłaszcza gdy dokumenty zawierają tabele i obrazy. · Prosty wyodrębni dowolną treść z dokumentu bez jej formatowania. · Automatyczny (zalecany) spróbuje przetworzyć przez Docling i w razie potrzeby przełączy się na prosty.",
    firecrawl: "Firecrawl",
    jina: "Jina",
    urlHelp: "· Firecrawl to płatna usługa (z darmowym planem), bardzo wydajna. · Jina również jest dobrym wyborem i także ma darmowy plan. · Prosty używa podstawowej ekstrakcji HTTP i pominie treść na stronach opartych na JavaScript. · Automatyczny (zalecany) spróbuje użyć Firecrawl, następnie Jina, a na końcu przełączy się na prosty.",
    embeddingAndSearch: "Osadzanie i wyszukiwanie",
    embeddingAndSearchDesc: "Skonfiguruj opcje wyszukiwania i osadzania",
    defaultEmbeddingOption: "Domyślna opcja osadzania",
    embeddingOptionPlaceholder: "Wybierz opcję osadzania",
    ask: "Pytaj",
    always: "Zawsze",
    never: "Nigdy",
    embeddingHelp: "Osadzenie treści ułatwi jej odnajdywanie zarówno Tobie, jak i Twoim agentom AI. Jeśli używasz lokalnego modelu osadzania (na przykład Ollama), nie musisz martwić się o koszty i możesz osadzać wszystko.",
    fileManagement: "Zarządzanie plikami",
    fileManagementDesc: "Skonfiguruj opcje obsługi i przechowywania plików",
    autoDeleteFiles: "Automatyczne usuwanie plików",
    autoDeletePlaceholder: "Wybierz opcję automatycznego usuwania",
    filesHelp: "Po przesłaniu i przetworzeniu plików nie są one już potrzebne. Większość użytkowników powinna pozwolić Open Notebook na automatyczne usuwanie przesłanych plików z folderu przesyłania.",
    loadFailed: "Nie udało się załadować ustawień",
  },
  advanced: {
    title: "Narzędzia zaawansowane",
    desc: "Zaawansowane narzędzia i funkcje dla zaawansowanych użytkowników",
    systemInfo: "Informacje o systemie",
    rebuildEmbeddings: "Przebuduj osadzenia",
    rebuildEmbeddingsDesc: "Przebuduj indeks wyszukiwania wektorowego dla wszystkich źródeł",
    currentVersion: "Bieżąca wersja",
    latestVersion: "Najnowsza wersja",
    status: "Status",
    updateAvailable: "Dostępna wersja {version}",
    updateAvailableDesc: "Dostępna jest nowa wersja Open Notebook.",
    upToDate: "Aktualna",
    unknown: "Nieznana",
    viewOnGithub: "Zobacz na GitHubie",
    updateCheckFailed: "Nie można sprawdzić aktualizacji. GitHub może być nieosiągalny.",
    rebuild: {
      mode: "Tryb przebudowy",
      existing: "Istniejące",
      all: "Wszystkie",
      existingDesc: "Ponownie osadź tylko elementy, które już mają osadzenia (szybsze, przy zmianie modelu)",
      allDesc: "Ponownie osadź istniejące elementy + utwórz osadzenia dla elementów, które ich nie mają (wolniejsze, kompleksowe)",
      include: "Uwzględnij w przebudowie",
      selectOneError: "Wybierz co najmniej jeden typ elementu do przebudowy",
      starting: "Rozpoczynanie przebudowy...",
      startBtn: "🚀 Rozpocznij przebudowę",
      queued: "W kolejce",
      running: "Przesyłanie zadań...",
      completed: "Zadania przesłane!",
      failed: "Niepowodzenie",
      leavePageHint: "Możesz opuścić tę stronę, ponieważ operacja będzie działać w tle",
      startNew: "Rozpocznij nową przebudowę",
      itemsProcessed: "Przesłano zadań: {processed}/{total} ({percent}%)",
      failedItems: "Nie udało się przesłać zadań: {count}",
      time: "Czas",
      whenToRebuild: "Kiedy powinienem przebudować osadzenia?",
      whenToRebuildAns: "Powinieneś przebudować przy zmianie modeli, aktualizacji wersji, naprawie uszkodzeń lub po imporcie masowym.",
      howLong: "Jak długo trwa przebudowa?",
      howLongAns: "Czas przetwarzania zależy od liczby elementów, szybkości modelu i limitów API. Modele lokalne są zwykle bardzo szybkie.",
      isSafe: "Czy przebudowa podczas korzystania z aplikacji jest bezpieczna?",
      isSafeAns: "Tak, przebudowa jest bezpieczna! Nie usuwa treści, jedynie zastępuje osadzenia i sprawnie obsługuje błędy.",
    },
  },
  transformations: {
    title: "Transformacje",
    desc: "Transformacje to prompty używane przez model LLM do przetwarzania źródła oraz wyodrębniania wglądów, podsumowań itp.",
    workspace: "Wybierz obszar roboczy",
    playground: "Piaskownica",
    defaultPrompt: "Domyślny prompt transformacji",
    defaultPromptDesc: "Zostanie dodany do wszystkich Twoich promptów transformacji",
    defaultPromptPlaceholder: "Wpisz swoje domyślne instrukcje transformacji...",
    listTitle: "Transformacje niestandardowe",
    createNew: "Utwórz nową",
    inputLabel: "Tekst wejściowy",
    inputPlaceholder: "Wpisz tekst do transformacji...",
    outputLabel: "Wynik",
    runTest: "Uruchom transformację",
    running: "Uruchamianie...",
    selectToStart: "Wybierz transformację, aby rozpocząć",
    name: "Nazwa",
    namePlaceholder: "Unikalny identyfikator, np. key_topics",
    titlePlaceholder: "Wyświetlany tytuł, domyślnie nazwa",
    promptPlaceholder: "Napisz prompt, który będzie napędzał tę transformację...",
    descriptionPlaceholder: "Opisz, co robi ta transformacja.",
    suggestDefault: "Sugeruj domyślnie dla nowych źródeł",
    promptHint: "Prompty należy pisać z myślą o treści źródła. Możesz poprosić model o podsumowanie, wyodrębnienie wglądów lub utworzenie ustrukturyzowanych wyników, takich jak tabele.",
    createSuccess: "Transformacja utworzona pomyślnie",
    updateSuccess: "Transformacja zaktualizowana pomyślnie",
    deleteSuccess: "Transformacja usunięta pomyślnie",
    noTransformations: "Brak transformacji",
    createOne: "Utwórz transformację, aby rozpocząć",
    selectModel: "Wybierz model",
    deleteConfirm: "Czy na pewno chcesz usunąć tę transformację?",
    model: "Model",
    systemPrompt: "Prompt systemowy",
    overrideModelDesc: "Nadpisz domyślny model dla tej sesji czatu. Pozostaw puste, aby użyć domyślnego modelu systemowego.",
    sessionUseReplacement: "Ta sesja użyje modelu {name} zamiast domyślnego.",
    systemDefault: "Domyślny systemowy",
  },
  models: {
    embedding: "Modele osadzania",
    tts: "Synteza mowy (TTS)",
    stt: "Rozpoznawanie mowy (STT)",
    apiKey: "Klucz API",
    deleteSuccess: "Model usunięty pomyślnie",
    saveSuccess: "Model zapisany pomyślnie",
    noModels: "Brak modeli",
    discoverModels: "Wykryj modele",
    noModelsFound: "Nie znaleziono modeli od tego dostawcy",
    modelType: "Typ modelu",
    modelTypeHint: "Wybierz typ modeli, które chcesz dodać. Jeśli potrzebujesz różnych typów, dodaj je w osobnych partiach.",
    deleteModel: "Usuń model",
    defaultAssignments: "Domyślne przypisania modeli",
    defaultAssignmentsDesc: "Skonfiguruj, których modeli używać do różnych celów w Open Notebook",
    missingRequiredModels: "Brakuje wymaganych modeli: {models}. Bez nich Open Notebook może nie działać poprawnie.",
    selectModelPlaceholder: "Wybierz model",
    requiredModelPlaceholder: "⚠️ Wymagane – wybierz model",
    chatModelLabel: "Model czatu",
    chatModelDesc: "Używany w rozmowach na czacie",
    transformationModelLabel: "Model transformacji",
    transformationModelDesc: "Używany do podsumowań, wglądów i transformacji",
    toolsModelLabel: "Model narzędzi",
    toolsModelDesc: "Używany do wywoływania funkcji – zalecane OpenAI lub Anthropic",
    largeContextModelLabel: "Model dużego kontekstu",
    largeContextModelDesc: "Używany do przetwarzania dużych dokumentów – zalecany Gemini",
    embeddingModelLabel: "Model osadzania",
    embeddingModelDesc: "Używany do wyszukiwania semantycznego i osadzeń wektorowych",
    ttsModelLabel: "Model syntezy mowy",
    ttsModelDesc: "Używany do generowania podcastów",
    sttModelLabel: "Model rozpoznawania mowy",
    sttModelDesc: "Używany do transkrypcji audio",
    embeddingChangeTitle: "Zmiana modelu osadzania",
    embeddingChangeConfirm: "Zamierzasz zmienić model osadzania z {from} na {to}.",
    rebuildRequired: "Ważne: wymagana przebudowa",
    rebuildReason: "Zmiana modelu osadzania wymaga przebudowy wszystkich istniejących osadzeń, aby zachować spójność. Bez przebudowy Twoje wyszukiwania mogą zwracać nieprawidłowe lub niekompletne wyniki.",
    whatHappensNext: "Co stanie się dalej:",
    step1: "Twój domyślny model osadzania zostanie zaktualizowany",
    step2: "Istniejące osadzenia pozostaną niezmienione do czasu przebudowy",
    step3: "Nowa treść będzie korzystać z nowego modelu osadzania",
    step4: "Powinieneś przebudować osadzenia jak najszybciej",
    proceedToRebuildPrompt: "Czy chcesz przejść do strony Zaawansowane, aby rozpocząć przebudowę teraz?",
    changeModelOnly: "Zmień tylko model",
    changeAndRebuild: "Zmień i przejdź do przebudowy",
    autoAssign: "Przypisz domyślne automatycznie",
    autoAssigning: "Przypisywanie...",
    autoAssignSuccess: "Automatycznie przypisano modeli domyślnych: {count}",
    autoAssignNoModels: "Brak modeli do przypisania. Najpierw zsynchronizuj modele.",
    autoAssignAlreadySet: "Wszystkie modele domyślne są już skonfigurowane",
    testModel: "Przetestuj model",
    testModelSuccess: "Test modelu zaliczony",
    testModelFailed: "Test modelu nie powiódł się",
    searchOrAddModel: "Szukaj lub wpisz nazwę modelu...",
    addCustomModel: "Dodaj „{name}”",
  },
  apiKeys: {
    title: "Skonfiguruj swoje AI za pomocą własnych kluczy API",
    description: "Przechowuj klucze API bezpiecznie w bazie danych, aby włączyć dostawców AI w Open Notebook.",
    encryptionRequired: "Klucz szyfrowania nie został skonfigurowany",
    encryptionRequiredDescription: "Ustaw zmienną środowiskową OPEN_NOTEBOOK_ENCRYPTION_KEY na dowolny tajny ciąg, aby umożliwić przechowywanie kluczy API w bazie danych.",
    configured: "Skonfigurowano",
    notConfigured: "Nieskonfigurowano",
    migrationAvailable: "Wykryto zmienne środowiskowe",
    migrationDescription: "Liczba kluczy API skonfigurowanych przez zmienne środowiskowe, które można przenieść do bazy danych w celu łatwiejszego zarządzania: {count}.",
    migrateToDatabase: "Przenieś do bazy danych",
    migrating: "Przenoszenie...",
    migrationSuccess: "Pomyślnie przeniesiono kluczy API: {count}",
    migrationErrors: "Nie udało się przenieść kluczy: {count}",
    migrationNothingToMigrate: "Wszystkie klucze są już w bazie danych",
    learnMore: "Dowiedz się, jak skonfigurować klucze API →",
    testConnection: "Przetestuj połączenie",
    testSuccess: "Połączenie udane",
    testFailed: "Test połączenia nie powiódł się",
    syncModels: "Synchronizuj modele",
    syncSuccess: "Wykryto {discovered} modeli, dodano {new} nowych",
    syncNoNew: "Wykryto {count} modeli, wszystkie są już zarejestrowane",
    syncFailed: "Nie udało się zsynchronizować modeli",
    getApiKey: "Uzyskaj klucz API",
    vertexProject: "Identyfikator projektu GCP",
    vertexLocation: "Region",
    vertexCredentials: "Ścieżka do pliku JSON konta usługi",
    addConfig: "Dodaj konfigurację",
    editConfig: "Edytuj konfigurację",
    deleteConfig: "Usuń konfigurację",
    configName: "Nazwa konfiguracji",
    configNameHint: "Opisowa nazwa tej konfiguracji (np. „Produkcja”, „Rozwój”)",
    baseUrl: "Bazowy adres URL",
    baseUrlOverrideHint: "Zmień to tylko wtedy, gdy musisz nadpisać domyślny punkt końcowy API dostawcy.",
    numCtx: "Okno kontekstu (num_ctx)",
    numCtxHint: "Maksymalne okno kontekstu dla modeli Ollama. Pozostaw puste, aby użyć wartości domyślnej (8192). Zwiększ tylko jeśli Twój sprzęt obsłuży większe okno.",
    deleteConfigConfirm: "Czy na pewno chcesz usunąć „{name}”? Tej operacji nie można cofnąć.",
    configSaveSuccess: "Konfiguracja zapisana pomyślnie",
    configUpdateSuccess: "Konfiguracja zaktualizowana pomyślnie",
    configDeleteSuccess: "Konfiguracja usunięta pomyślnie",
    apiKeyEditHint: "Pozostaw puste, aby zachować istniejący klucz API",
    decryptionError: "Błąd odszyfrowywania",
    decryptionErrorDescription: "Nie udało się odszyfrować klucza API tego poświadczenia. Klucz szyfrowania mógł ulec zmianie. Usuń to poświadczenie i utwórz je ponownie z prawidłowym kluczem.",
  },
  setupBanner: {
    encryptionRequired: "Klucz szyfrowania nie został skonfigurowany",
    encryptionRequiredDescription: "Ustaw zmienną środowiskową OPEN_NOTEBOOK_ENCRYPTION_KEY, aby umożliwić bezpieczne przechowywanie poświadczeń.",
    migrationAvailable: "Dostępna migracja kluczy API",
    migrationDescription: "Liczba dostawców z kluczami API ustawionymi przez zmienne środowiskowe: {count}. Przenieś je do bazy danych w celu łatwiejszego zarządzania.",
    goToSettings: "Przejdź do Ustawień",
    viewDocs: "Zobacz dokumentację",
  },
}
